import {Injectable} from "@angular/core";
import {FileService, ProjectService, WmHttpService} from "@wms/services";
import {Config, NewProps} from "@wms/settings/prefab-config";
import {Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class PrefabConfigurationService {

  prefabConfig: Config;
  newProps: NewProps;
  isDirty: any;
  isInvalid: any;
  prefabIconUpdated: boolean;
  showErrorMsg: boolean;
  errorMsg: string;
  appEnvModified: boolean;
  hideErrorMsg$: Subject<void>;
  iconUpload$: Subject<any>;
  isPrefabProject: boolean;
  resetForm = new Subject();

  constructor(private fileService: FileService, private projectService: ProjectService, private httpService: WmHttpService) {
    this.newProps           = {};
    this.isDirty            = {};
    this.isInvalid          = {};
    this.showErrorMsg       = false;
    this.errorMsg           = '';
    this.prefabIconUpdated  = false;
    this.appEnvModified     = false;
    this.hideErrorMsg$      = new Subject<void>();
    this.iconUpload$        = new Subject();
    this.isPrefabProject    = this.projectService.isPrefabType();
  }

  iconUploadObservable() {
    return this.iconUpload$.asObservable();
  }

  hideErrorMsgObservable() {
    return this.hideErrorMsg$.asObservable();
  }

  setConfig(config: Config) {
    this.prefabConfig = config;
  }

  getConfig(): Config {
    return this.prefabConfig;
  }

  showErrorMessage(msg: string) {
    this.showErrorMsg = true;
    this.errorMsg     = msg;
  }
  fetchPrefabConfig(): Promise<any> {
    return (this.httpService.execute({
      target: 'FILE',
      action: 'read',
      pathParams: {
        projectID: this.projectService.getProjectId(),
        filePath: 'config.json'
      }
    }) as Promise<any>);
  }

}
